import { Box } from '@mui/material';

export const Admin = () => {
    return <Box sx={{ flex: 1 }}></Box>;
};
